export const Endpoints = {
  // ** Common
  // ** Auth
  login: "/auth/signin",
  register: "/auth/signup",
  refresh: "/auth/refresh-token",
  logout: "/auth/logout",
  verifyEmail: "/auth/verifyOTP",
  resendOtp: "/auth/resendOTP",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  loginWithSSO: "/auth/loginViaAzureSSO",
  jobQuestionSets:"/job/job_post_questions",
  approvalWorkFlow:"/approval_workflow",
  MyApprovals:"/my_approvals",
  Notifications: '/notifications',
  NotificationsUnreadCount: '/notifications/unread-count',
  NotificationsMarkAsRead: '/notifications',
  NotificationsMarkAllAsRead: '/notifications/read-all',


  // ** Jobs
  getAllJobs: "/job/job_post", // get all jobs that are posted by company ,add id in params to get specific job
  getKanbanJobs: "/job/get-job-post-activity", // get all jobs that are posted by company ,add id in params to get specific job
  getAppliedJobs: "/job/appliedApplicants", // get all jobs that are applied by user ,add id in params to get specific job {GET} and apply for job {POST}
  getSpecificApplicant: "/job/applicant",
  // countries
  //getAllCountries: "https://restcountries.com/v2/all",
  getAllCountries: "https://countriesnow.space/api/v0.1/countries/capital",
  // states
  getAllStates: "https://countriesnow.space/api/v0.1/countries/states",
  // cities
  getAllCities: "https://countriesnow.space/api/v0.1/countries/state/cities",
  // resume
  // uploadResume: "/seeker_profile/upload_cv",
  uploadResume: "/seeker_profile/upload_cv",

  // profile
  getProfile: "/seeker_profile/profile",
  // create profile
  createProfile: "/seeker_profile/create_whole_profile",

  // JOB CATEGORY {GET} , {POST} , {PATCH} , {DELETE}
  jobCategories: "/job/job_category",
  // skills
  getSkills: "/seeker_profile/skill_set",
  // Department
  department: "/company/departments",
  // get all job templates
  getAllJobTemplates: "/job/templates",

  //get profile experience
  getProfileExperience: "/seeker_profile/experience_details",
  //get profile experience
  getProfileEducation: "/seeker_profile/education_details",
  //get profile SKillsets
  getProfileSkillsets: "/seeker_profile/profile",
  //get profile Languages
  getProfileLanguages: "/seeker_profile/seeker_languages",
  //get profile References
  getProfileReferences: "/seeker_profile/reference",
  //get profile Certificates
  getProfileCertificates: "/seeker_profile/certification",
  //get profile Attachments
  getProfileAttachments: "/seeker_profile/attachment",

  companyProfile: "/company",
  companyProfileLocation: "/company/location",

  Skills: "/seeker_profile/skill_set",
  generateJobDescription: "/job/generate_jd_via_ai",

  getApplicantsInfo: "/job/getApplicantsCount",
  oAuthGenerate: "/company/oAuthCredentials",
  changePassword: "/user/changeUserPassword",
  companyLogo: "/company/uploadLogo",
  candidates:"/user/candidates",

  getAllFeatures: "/feature",
  getAllGroups: "/access/roleGroup",
  listOfGroups: "/access/listOfRoleGroups",
  user: "/user/companyUser",
  getPlans: "/plansAndPricing/listOfPlans",
  getAPILimits: "/company/getApiCallLimit",
  createZoomMeeting: "/integration/zoom/meeting",
  getAllMeetings: "/integration/meeting",
  integrateZoom: "/integration/zoom/config",
  integrateTeams: "/integration/teams/config",
  teamsClientConnect: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}&scope=${process.env.REACT_APP_SCOPES}`,
  graphApplicantStatus: "/dashboard/graph/applicant-status",
  graphApplicantReport: "/dashboard/graph/applicant-bar-graph-statistics",
  graphStats: "/dashboard/graph/statistics",
  createTeamsMeeting: "/integration/teams/meeting",
  integrateLinkedIn: "/integration/linkedin/config",
  fetchLinkedInAccessToken: "/integration/linkedin/generateLinkedinToken",
  linkedInJobPost: "/integration/linkedin/createPost",
  generateSkillTest: "/job/generateOnlineSkillTest",
  AuthorizedUris: "/company/authorizedUri",
  createEvaluation: "/forms/evaluation_form",
  scheduleOnBoarding: "/job/applicant/specific",
  submitEvaluationForm: "/onboarding/interviews/specific",
  interviewers: "/user/employees",
  assignedEvaluation: "/onboarding/interviews",
  cancelInterview: "/onboarding",
  rejectApplicant: "/job/applicant/specific",
  uploadOfferLetter: "/onboarding/uploadOfferLetter",
  sendOfferLetter: "/onboarding/applicant",
  profileAssessment: "/assessment/profile",
  createAssessment: "/forms/assessment_question",
  createBulkAssessment: "/forms/assessment_question/bulk-creation",
  submitInterviewTest: "/assessment/technical/applicant/specific",
  integrateFo: "/integration/finance_and_operations/config",
  sendDataToFO: "/job/applicant/post_data_to_fo/specific",
  paymentStripe: "company/plan-change",
  cancelSubscription: "/company/plan-cancel",
  paymentPaypalCapture: "/company/plan-change",
  uploadResumeCloud: "/seeker_profile/upload_cv_cloud",
  addApplicantInternally: "/seeker_profile/create_applicant_profile_internal",
  uploadCertificate: "/seeker_profile/upload_certificate",
  uploadAttachment: "/seeker_profile/upload_attachment",
  JobApprovalProcess: "/company/configuration",
  jobPostApproval: "/job/job_post",
  changeJobStatus : "/job/job_post",
  getAllInternalUsers: "/dropdown/internal-users",

  //* Dashboard Endpoints Start */
  getTotalJobsAndApplicant: "/dashboard/graph/total-applicants-and-jobs",
  getTotalApplicantsReports: "/dashboard/graph/total-applicants-reports",
  getOpenJobByCategory: "/dashboard/graph/open-job-by-category",
  getTotalApplicantsFunnel: "/dashboard/graph/total-applicants-funnel",
  getApplicationsReceivedByCategory:
    "/dashboard/graph/application-receive-by-category",
  getJobPostByJobType: "/dashboard/graph/job-post-by-job-type",
  getJobAcceptedRatio: "/dashboard/graph/job-accepted-ratio",
  getJobByTitle: "/dashboard/graph/job-by-title",
  getLocationData: "/dashboard/graph/location-data",
  getApplicantByGender: "/dashboard/graph/applicant-by-gender"
  //* Dashboard Endpoints End */
}

// /job/applicant/specific/:id/technicalAssessment
